var map = {
	"./badge_challenge_2.png": 497,
	"./badge_health_2.png": 498,
	"./badge_highfive_2.png": 499,
	"./badge_level_1_2.png": 500,
	"./badge_level_2_2.png": 501,
	"./badge_level_3_2.png": 502,
	"./badge_level_4_2.png": 503,
	"./badge_level_5_2.png": 504,
	"./badge_level_6_2.png": 505,
	"./badge_money_2.png": 506,
	"./badge_share_2.png": 507,
	"./badge_support_2.png": 508,
	"./badge_supporting_2.png": 226
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 496;


//////////////////
// WEBPACK FOOTER
// ./src/icons/badges ^\.\/badge_.*_2\.png$
// module id = 496
// module chunks = 0